import { Tooltip, TooltipContent, TooltipTrigger } from "@design-system/shadcn";
import React, { type ReactNode } from "react";

import { useFilters } from "../filters-provider";

interface FilterBarFieldProps {
  name: string;
  tooltip?: string;
  children: ReactNode;
}

function FilterBarField({ name, tooltip, children }: FilterBarFieldProps) {
  const { visibleFilters } = useFilters();

  if (!visibleFilters.includes(name)) {
    return null;
  }

  if (!tooltip) {
    return <>{children}</>;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex">{children}</span>
      </TooltipTrigger>
      <TooltipContent>{tooltip}</TooltipContent>
    </Tooltip>
  );
}

export { FilterBarField };
export type { FilterBarFieldProps };
